import axios from 'axios';
import one360 from './one360';
import { AuthUser } from '../../types/auth';

export async function fetchMeAsync(idToken: string): Promise<AuthUser> {
  try {
    return await one360.get<AuthUser>('/api/v1/auth/me', {
      headers: { Authorization: `Bearer ${idToken}` },
    });
  } catch (err: any) {
    if (axios.isCancel(err)) throw err;
    console.error('[Auth] fetchMe fehlgeschlagen:', err);
    throw err;
  }
}
